<template>
  <div
    class="criteria-container"
    v-if="criteriaAvailable"
  >
    <div
      class="criteria-list"
      v-if="staticCriteria"
      :style="minWidth"
    >
      <criterion
        v-for="criterion in staticCriteria"
        :key="'static' + criterion.Hash"
        :criterion="criterion"
        :show-value="true"
        :show-delete="true"
        @deleteCriterion="deleteStaticCriterion"
      />
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'

import Criterion from './Criterion.vue'

export default {
  name: 'CriteriaList',
  components: {
    'criterion': Criterion
  },
  props: {
    staticCriteria: {
      default: function () {
        return []
      },
      type: Array
    }
  },
  methods: {
    'deleteStaticCriterion' (criterion) {
      this.$emit('deleteStaticCriterion', criterion)
    }
  },
  computed: {
    criteriaAvailable () {
      let self = this
      return _.size(self.staticCriteria) > 0
    },
    minWidth () {
      let self = this
      return {'min-width': _.size(self.staticCriteria) * 100 + 'px'}
    }
  }
}
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../../kit-components/uikit';

  .criteria-container {

    .criteria-list {
      border-left: none;
      border-right: none;
      background: $lightGreyBackground;
      max-height: 35px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/grid/Criteria/CriteriaList.vue